import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=38e94da7&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=38e94da7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e94da7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e94da7')) {
      api.createRecord('38e94da7', component.options)
    } else {
      api.reload('38e94da7', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=38e94da7&scoped=true&", function () {
      api.rerender('38e94da7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d2e2SgEypq8J/JS/comp/PopupDialog.vue"
export default component.exports